import { createContext } from 'react';
import IPlatformConfig from '../model/IPlatformConfig';

const PlatformConfigContext = createContext<IPlatformConfig>(null);

export default PlatformConfigContext;
